export class Exception extends Error {
    public readonly msg: string;
    public readonly context?: unknown;

    constructor(msg: string, context?: unknown) {
        super(msg);
        this.msg = msg;
        this.context = context;
        this.name = this.constructor.name;
        Object.setPrototypeOf(this, new.target.prototype); // Ensure correct prototype chain
    }

    toJSON() {
        return {
            name: this.name,
            message: this.msg,
            context: this.context,
            stack: this.stack,
        };
    }
}


export class FatalError extends Exception {
}

export class AuthError extends Exception {
    public readonly statusCode: number; // HTTP status code for auth errors (e.g., 401, 403)
    public readonly errorCode?: string; // Optional application-specific error code

    constructor(
        msg: string,
        context?: unknown,
        statusCode: number = 401, // Default to "Unauthorized"
        errorCode?: string // Optional error codes like "INVALID_TOKEN" or "FORBIDDEN"
    ) {
        super(msg, context);
        this.statusCode = statusCode;
        this.errorCode = errorCode;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            statusCode: this.statusCode,
            errorCode: this.errorCode,
        };
    }
}